module.exports = __webpack_public_path__ + "img/content_ic_increase.882ba14f.svg";